import { memo } from "react";
import ECommerceSettingsStatusCassette from "../ECommerceSettingsStatusCassette";
import usePlatformStatus from "./usePlatformStatus";

const PlatformStatus = () => {
    const settings = usePlatformStatus();

    return (
        <ECommerceSettingsStatusCassette
            title='E-Commerce Platform Status'
            settings={settings}
        />
    );
};

export default memo(PlatformStatus);
